import {Component, ElementRef, inject, input, OnInit, viewChild} from '@angular/core'
import {AbstractControl, FormGroup, ReactiveFormsModule} from '@angular/forms'
import {MatButton} from '@angular/material/button'
import {MatError} from '@angular/material/form-field'
import {MatProgressBar} from '@angular/material/progress-bar'
import {MatStepperNext, MatStepperPrevious} from '@angular/material/stepper'
import {KycType, KycTypeMap} from '@sparbanken-syd/spb-savings-account-backend/dist'
import {Interest, InterestService} from '../../services/interest.service'
import {OrientationService} from '../../services/orientation.service'
import {SavingsAccountService} from '../../services/savings-account.service'
import {BirthComponent} from './01-birth/birth.component'
import {PrimaryResidenceComponent} from './02-primary-residence/primary-residence.component'
import {GreenCardComponent} from './03-green-card/green-card.component'
import {AmericanCitizenshipComponent} from './04-american-citizenship/american-citizenship.component'
import {TaxResidencyComponent} from './05-tax-residency/tax-residency.component'
import {PepComponent} from './06-pep/pep.component'
import {BankRelationshipComponent} from './07-bank-relationship/bank-relationship.component'
import {IncomeComponent} from './08-income/income.component'
import {SavingsComponent} from './09-savings/savings.component'


@Component({
  selector: 'spb-kyc',
  templateUrl: './kyc.component.html',
  styleUrls: ['./kyc.component.scss'],
  imports: [ReactiveFormsModule, MatProgressBar, BirthComponent, PrimaryResidenceComponent, GreenCardComponent, AmericanCitizenshipComponent, TaxResidencyComponent, PepComponent, BankRelationshipComponent, IncomeComponent, SavingsComponent, MatError, MatStepperPrevious, MatButton, MatStepperNext]
})
export class KycComponent implements OnInit {
  public kycFormElement = viewChild('kycFormElement') as unknown as (() => ElementRef)
  public kycForm = input.required<FormGroup>()
  public currentStep = 0
  public totalSteps = 9
  public showWarningText = false
  public latestInterest!: Interest
  protected KycType = KycType
  protected readonly savingsAccountService = inject(SavingsAccountService)
  protected readonly orientationService = inject(OrientationService)
  private readonly interestService = inject(InterestService)

  public ngOnInit() {
    this.interestService.getLatestInterest().subscribe(
      interest => this.latestInterest = interest
    )
  }

  public nextStep(form: AbstractControl) {
    this.showWarningText = false

    if (this.currentStep === 6 && (!form.value.openSavingsAccount && !form.value.existingSavingsAccountNumber)) {
      this.showWarningText = true
      return
    }

    if (this.currentStep < this.totalSteps) {
      this.currentStep++
    }
    this.setFocusToFirstTab()
  }

  public previousStep() {
    this.showWarningText = false
    if (this.currentStep > 0) {
      this.currentStep--
    }
    this.setFocusToFirstTab()
  }

  public disabledButton() {
    // Use KycTypeMap to convert the currentStep enum value to its string representation
    const stepName = KycTypeMap.get(this.currentStep)

    // Access the form control based on the string representation
    const validationFunction = () => !this.kycForm().controls[`${stepName}Form`].valid

    // Return the result of the validation function (true or false)
    return validationFunction()
  }

  protected getFormGroup(control: AbstractControl) {
    return control as FormGroup
  }

  private setFocusToFirstTab() {
    // Timeout to ensure DOM has been updated
    setTimeout(() => {
      this.kycFormElement().nativeElement.querySelectorAll(
        '[tabindex]:not([tabindex="-1"])'
      )[0]?.focus()

      this.scrollToTop()
    }, 100)
  }

  private scrollToTop() {
    this.kycFormElement().nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }
}